import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Input, Table, Button } from 'antd'
import moment from 'moment'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import ErrorModal from '@Modal/ErrorModal'
import SuccessModal from '@Modal/SuccessModal'
import { http } from '@services/http'
import {
	fetchPurchasesIncoming,
	fetchLandedCostsByPurchaseInvoice,
} from '@utils/fetchData'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'

import CreteLandedCostsModal from '../createLandedCostsModal'


const ViewDetailedPurchaseIncomingModal = ({
	visible,
	onClose,
	data,
	finishSale = false,
	isShowLandedCosts = false,
	refetch,
}) => {
	const { t } = useTranslation()

	const successRef = useRef()
	const errorRef = useRef()

	const roleNames = useSelector((state) => state.main.roleNames)
	const employeeId = useSelector((state) => state.main.employeeId)
	const salesPersonCode = useSelector((state) => state.main.salesPersonCode)

	const [dueDate, setDueDate] = useState('')
	const [shipBtnLoading, setShipBtnLoading] = useState(false)
	const [status, setStatus] = useState('')
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [dopZatrataModal, setDopZatrataModal] = useState(false)
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)

	const {
		data: landedCostsData = [],
		isLoading: loadingLandedCosts,
		refetch: refetchLandedCosts,
	} = useQuery({
		queryKey: ['landedCosts', data?.docEntry],
		queryFn: fetchLandedCostsByPurchaseInvoice,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		enabled: !!data?.docEntry,
	})

	useEffect(() => {
		if (data?.docDueDate) {
			let date = ''
			;(finishSale && roleNames.includes('Supplier')) ||
			roleNames.includes('admin')
				? (date = moment().format('YYYY-MM-DD'))
				: (date = moment(data?.docDueDate).format('YYYY-MM-DD'))
			setDueDate(date)
			console.log(date)
		}
		if (data?.u_Status) {
			setStatus(data.u_Status)
		}
		console.log('Data  = ', data)
	}, [data])

	if (!data) return null

	const columns = [
		{
			title: t('item'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			width: 150,
			render: (text, record, index) => {
				return <span>{text}</span>
			},
		},

		{
			title: t('quantityN'),
			dataIndex: 'realQuantity',
			key: 'realQuantity',
			render: (text, record, index) => {
				const formattedText = numberWithSpacesIntl(text)
				return <span> {formattedText}</span>
			},
		},
		{
			title: t('kv.m'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, record, index) => {
				const formattedText = numberWithSpacesIntl(text)
				return <span>{formattedText}</span>
			},
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record, index) => {
				const formattedText = numberWithSpacesIntl(text)
				return (
					<span>
						{formattedText} {record?.currency}
					</span>
				)
			},
		},

		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record?.currency}
					</span>
				)
			},
		},
		{
			title: t('whs'),
			dataIndex: 'whsName',
			key: 'whsName',
		},
	]

	const tableData = data?.documentLines.map((item, index) => ({
		key: index,
		itemDescription: item.itemDescription,
		quantity: item.quantity,
		price: item.price,
		lineTotal: item.lineTotal,
		whsName: item.whsName,
		ugpCode: item.ugpCode,
		realQuantity: item.quantity / item.itemKvMetr,
		currency: item.currency,
	}))

	return (
		// <Modal
		// 	title={
		// 		<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
		// 			{t('order')} № {data?.docNumPrefix}
		// 		</h1>
		// 	}
		// 	open={visible}
		// 	onCancel={onClose}
		// 	footer={null}
		// 	closeIcon={<CloseOutlined />}
		// 	width="90%"
		// >
		<div className="w-full px-4 sm:px-14">
			<div className="w-full">
				<div className="mt-10 flex flex-col items-center justify-between sm:flex-row">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('mijoz')}</p>
						<Input
							type="text"
							value={data.cardName}
							className="flex  w-[200px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					{data.u_Status && (
						<div className="flex flex-col gap-3">
							<p className="font-bold">{t('status')}</p>
							<Input
								value={t(`${status}`)}
								style={{ color: 'black' }}
								className="flex  w-[200px] items-center justify-center sm:w-[250px]"
								disabled
							/>
						</div>
					)}

					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('currency')}</p>
						<Input
							value={data.documentLines[0].currency}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('date')}</p>
						<Input
							type="date"
							value={dueDate}
							style={{ color: 'black' }}
							onChange={(e) => {
								console.log(e.target.value)
								setDueDate(e.target.value)
							}}
							disabled={true}
						/>
					</div>
				</div>
				<Table
					columns={columns}
					dataSource={tableData}
					pagination={false}
					className="border-1 mt-12 border-black"
					scroll={{ x: '100%' }}
					bordered
				/>

				<div className="w-full flex items-center justify-between mt-20  ">
					<div className="flex flex-col items-start gap-3 ">
						<p className="font-bold">{t('totalForDocument')}</p>
						<Input
							type="text"
							value={`${new Intl.NumberFormat('fr-FR').format(data.docTotal)} ${data.docCurrency}`}
							className="flex h-8 w-[70px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="flex flex-col items-start gap-3 ">
						<p className="font-bold">{t('comments')}</p>
						<Input.TextArea
							type="text"
							value={data?.comments}
							className="flex h-8 w-[70px] items-center justify-center sm:w-[350px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
				</div>
				<div className="w-full flex items-center justify-end gap-3 mt-10">
					{isShowLandedCosts && (
						<Button
							onClick={() => {
								setDopZatrataModal(true)
								console.log('Button Clicked')
							}}
							loading={shipBtnLoading || loadingLandedCosts}
							disabled={landedCostsData.length > 0}
							className="h-[30px] bg-[#0A4D68] rounded-lg text-white"
						>
							{t('addLandedCosts')}
						</Button>
					)}
				</div>
			</div>

			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<CreteLandedCostsModal
				visible={dopZatrataModal}
				data={data}
				docDate={moment().format('YYYY-MM-DD')}
				onClose2={() => {
					setDopZatrataModal(false)
					refetchLandedCosts()
				}}
				refetch={() => refetch?.()}
			/>
		</div>
		// </Modal>
	)
}

export default ViewDetailedPurchaseIncomingModal
